import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

import {
	isStandalonePage,
	openStandalonePage,
} from "apps/messenger/util/helpers";
import ScaleFadeTransition from "shared/components/ScaleFadeTransition";
import ClickWatcher from "shared/components/ClickWatcher";
import Str from "shared/components/Str";
import Context from "shared/util/Context";
import Analytics from "analytics/util/Analytics";

import "apps/messenger/components/shared/MessengerUserRow/UserMenu.scss";

const isDesktop = process.env.PLATFORM === "desktop";

const UserMenu = ({
	userid,
	nway,

	children,
	onUnmatch,
	onBlock,
	onReport,
	closeConversation,
	allowReport,
	isMutualLike,
}) => {
	// Menu toggling.
	const [userMenuVisible, setUserMenuVisible] = useState(false);
	const _onToggleUserMenu = useCallback(
		() => setUserMenuVisible(!userMenuVisible), [userMenuVisible],
	);

	// Menu actions.
	const _onOpenInNewWindow = useCallback(() => {
		openStandalonePage(userid);
		closeConversation(userid);

		Analytics.logUIEvent(
			Analytics.eventNames.poppedOutConversation,
			{
				data: {
					"user id": Context.get("userid"),
					"taget user id": userid,
					"nway": nway,
				},
			},
		);
	}, [closeConversation, userid, nway]);
	const _onUnmatch = useCallback(() => onUnmatch(userid), [onUnmatch, userid]);
	const _onBlock = useCallback(() => onBlock(userid), [onBlock, userid]);
	const _onReport = useCallback(() => onReport(userid), [onReport, userid]);

	return (
		<ClickWatcher
			className="messenger-user-menu-container"
			onOutsideClick={_onToggleUserMenu}
			active={userMenuVisible}
		>
			{children(_onToggleUserMenu)}

			<ScaleFadeTransition speed={ScaleFadeTransition.speeds.Half}>
				{userMenuVisible && (
					<div className="messenger-user-menu">
						{isMutualLike && isDesktop && !isStandalonePage && (
							<button className="messenger-user-menu-item" onClick={_onOpenInNewWindow}>
								<Str>Pop-Out</Str>
							</button>
						)}
						{isMutualLike && (
							<button className="messenger-user-menu-item" onClick={_onUnmatch}>
								<Str>Unmatch</Str>
							</button>
						)}
						<button className="messenger-user-menu-item" onClick={_onBlock}>
							<Str>Block</Str>
						</button>
						{allowReport && (
							<button className="messenger-user-menu-item" onClick={_onReport}>
								<Str>Report</Str>
							</button>
						)}
					</div>
				)}
			</ScaleFadeTransition>
		</ClickWatcher>
	);
};

UserMenu.propTypes = {
	userid: PropTypes.string.isRequired,
	nway: PropTypes.number.isRequired,
	children: PropTypes.func.isRequired,
	onUnmatch: PropTypes.func.isRequired,
	onBlock: PropTypes.func.isRequired,
	onReport: PropTypes.func.isRequired,
	closeConversation: PropTypes.func.isRequired,
	allowReport: PropTypes.bool.isRequired,
	isMutualLike: PropTypes.bool.isRequired,
};

export default UserMenu;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/shared/MessengerUserRow/UserMenu.jsx